export const carreraNormalize = (x) => ({
    idCarrera: x.idCarrera ?? x.IdCarrera ?? 0,
    nombre: x.nombre ?? x.Nombre ?? '',
    descripcion: x.descripcion ?? x.Descripcion ?? '',
    idCertificado: x.idCertificado ?? x.IdCertificado ?? null,
    activado: x.activado ?? x.Activado ?? true,
    urlImagen: x.urlImagen ?? x.UrlImagen ?? '',
    publicado: x.publicado ?? x.Publicado ?? false,
    idInstructor: x.idInstructor ?? x.IdInstructor ?? 0
});
